import config from '@/config';

function isContactsV2Enabled(): boolean {
  return config.CONTACTS_API_ENABLED;
}

export default isContactsV2Enabled;
